// Helper for resolving widget asset URLs (icons, country flags, provider
// logos) against the configured BFF api-base. Without this prefix the
// widget would fetch `/assets/...` from the host page's origin when
// embedded on a portal — those paths only exist on the BFF.
//
// Rules:
//   - empty / nullish path → empty string (caller decides on fallback)
//   - absolute (http/https/data:/blob:) → leave alone, host/portal already
//     gave us a fully-qualified URL
//   - relative (`/assets/...` or `assets/...`) → prefix with apiBase
//   - apiBase empty (same-origin landing) → leave path as-is

export function assetUrl(
  apiBase: string,
  path: string | undefined | null,
): string {
  if (!path) return '';
  if (
    path.startsWith('http://') ||
    path.startsWith('https://') ||
    path.startsWith('data:') ||
    path.startsWith('blob:')
  ) {
    return path;
  }
  if (!apiBase) return path;
  if (path.startsWith('/')) return apiBase + path;
  return apiBase + '/' + path;
}
